import { UserOutlined } from '@ant-design/icons';
import {
  AInput,
  AButton,
  ContainerForm,
  PageIntro,
  PageLayout,
  PagePanel,
} from '../../components';
import { Col, Form, Row } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import { mask, phoneMask } from '../../shared/utils/functions';
import { useToast } from '../../hooks/toast';
import { useNavigate } from 'react-router-dom';
import { schemaEditUser } from '../Users/schemas/yup.user.schema';
import { useAuth } from '../../hooks/auth';
import { patchUser } from '../../http';

const Profile: React.FC = () => {
  const { user, updateUser } = useAuth();
  const { addToast } = useToast();
  const navigate = useNavigate();
  const [name, setName] = useState<string>();
  const [cpf, setCpf] = useState<string>();
  const [birthday, setBirthday] = useState<string>();
  const [phone, setPhone] = useState<string>();
  const [email, setEmail] = useState<string>();

  const handleEditSubmit = useCallback(async () => {
    schemaEditUser
      .validate({
        name,
        cpf,
        birthday,
        phone,
        email,
      })
      .then(async (formValidated: any) => {
        await patchUser(user.id, formValidated)
          .then((data) => {
            updateUser(data);
            addToast({
              type: 'success',
              title: 'Usuário alterado',
              description: 'Dados de usuário alterado com sucesso.',
            });
          })
          .catch((error) => {
            addToast({
              type: 'error',
              title: 'Erro',
              description: `${error.response.data.error ?? 'Erro ao alterar.'}`,
            });
          });
      })
      .catch((err) => {
        addToast({
          type: 'error',
          title: 'Campos em branco',
          description: err.errors,
        });
        return;
      });
  }, [addToast, birthday, cpf, email, name, phone]);

  useEffect(() => {
    setName(user.name);
    setCpf(user.cpf);
    setBirthday(user.birthday);
    setPhone(user.phone);
    setEmail(user.email);
  }, [user]);

  return (
    <PageLayout>
      <PageIntro
        badge="Conta"
        icon={<UserOutlined />}
        title="Minha conta"
        description="Atualize seus dados de acesso e contato mantendo o mesmo padrão visual das demais telas internas."
      />
      <PagePanel>
        <ContainerForm>
          <Form layout="vertical" style={{ width: '80%' }}>
            <Row>
              <Col span={24}>
                <Form.Item label="Nome" required>
                  <AInput
                    placeholder="Insira o nome"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={12}>
                <Form.Item label="CPF" required>
                  <AInput
                    placeholder="Insira o CPF"
                    value={cpf}
                    maxLength={14}
                    onChange={(e) => setCpf(mask(e.target.value))}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Data Nascimento" required>
                  <AInput
                    value={birthday}
                    type="date"
                    onChange={(e) => setBirthday(e.target.value)}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={12}>
                <Form.Item label="Telefone" required>
                  <AInput
                    placeholder="Insira o Telefone"
                    value={phone}
                    maxLength={15}
                    onChange={(e) => setPhone(phoneMask(e.target.value))}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="E-mail" required>
                  <AInput
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row justify="end">
              <AButton type="default" onClick={() => navigate('/dashboard')}>
                Voltar
              </AButton>
              <AButton type="primary" onClick={handleEditSubmit}>
                Salvar
              </AButton>
            </Row>
          </Form>
        </ContainerForm>
      </PagePanel>
    </PageLayout>
  );
};

export default Profile;
